<script lang="ts">

</script>
<ul class="rating-star">
    <li><i class="fa fa-star" /></li>
    <li><i class="fa fa-star" /></li>
    <li><i class="fa fa-star" /></li>
    <li><i class="fa fa-star" /></li>
    <li><i class="fa fa-star" /></li>
</ul>